import * as React from "react";
import { Box, Modal, Typography } from "@mui/material";
import { getUrl } from "@aws-amplify/storage";
import { useTranslation } from "react-i18next";

export default function ImageModal({
  imageKey,
  displayNoImg = false,
  boxWidth = 100,
  boxHeight = 100,
}) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    bgcolor: "background.paper",
    border: "1px solid #777",
    boxShadow: 24,
    p: { xs: 1, sm: 4 },
    maxWidth: "90vw",
    maxHeight: "90vh",
    alignContent: "center",
    alignItems: "center",
    borderRadius: 3,
  };

  const [imageUrl, setImageUrl] = React.useState("");

  async function getImage() {
    if (!imageKey) {
      setImageUrl("");
      return;
    }
    let imgUrl;
    try {
      const result = await getUrl({
        key: imageKey,
        options: {
          validateObjectExistence: true,
        },
      });
      imgUrl = result.url;
    } catch (err) {
      console.error(err);
      imgUrl = "";
    }
    setImageUrl(imgUrl);
  }

  React.useEffect(() => {
    getImage();
  }, [imageKey]);

  return (
    <div>
      {imageUrl !== "" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            userSelect: "none",
          }}
          onClick={() => setOpen(true)}
        >
          <Box
            component="img"
            draggable={false}
            sx={{
              width: boxWidth,
              height: "auto",
              maxHeight: boxHeight,
              borderRadius: 3,
              objectFit: "contain",
              "&:hover": {
                cursor: "pointer",
                transform: "scale(1.1)",
              },
            }}
            alt={"img"}
            src={imageUrl}
          />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: boxWidth,
            maxHeight: boxHeight,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {displayNoImg && (
            <Typography
              align="center"
              sx={{
                fontSize: 15,
                userSelect: "none",
                border: 1,
                borderRadius: 2,
                borderColor: "#999",
                color: "#999",
                p: 2,
              }}
            >
              {t("noImageUploaded")}
            </Typography>
          )}
        </Box>
      )}
      <Modal open={open} onClose={() => setOpen(false)} disableAutoFocus={true}>
        <Box sx={style}>
          <Box
            component="img"
            draggable={false}
            sx={{
              objectFit: "contain",
              maxWidth: "80vw",
              maxHeight: "80vh",
              userSelect: "none",
            }}
            alt={"img"}
            src={imageUrl}
          />
          {/* <Typography
                  noWrap
                  sx={{ fontSize: 14, px: 1, justifySelf: "center" }}
                >
                  {imageTitle}
                </Typography> */}
        </Box>
      </Modal>
    </div>
  );
}
